<!--
    @description :
    @api-property :
    @api-event :
    @api-method :

    @author :
    @dateTime :
    @lastEditDateTime :
    @lastEditors :
-->
<template>
  <div>
    <div
      style="
        background-color: #35a8a4;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      "
    >
      <div style="width: 100%; position: relative">
        <img src="@/assets/contactus-bg.jpg" alt="" style="width: 100%" />
        <p
          style="
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 30px;
            font-weight: bold;
          "
        >
          <span style="color: #35a8a4">联系</span
          ><span style="color: #fff">我们</span>
        </p>
      </div>
      <div style="height: 20px; width: 100%; background-color: #fff"></div>
      <div
        style="
          background-color: #35a8a4;
          padding: 20px 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          "
        >
          <img
            src="@/assets/customerwechat.png"
            alt=""
            style="width: 250px; height: 280px"
          />
          <img
            src="@/assets/wechat-icon.png"
            alt=""
            style="
              width: 50px;
              height: 50px;
              margin-top: 20px;
              margin-left: 20px;
            "
          />
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-left: 20px;
          "
        >
          <img
            src="@/assets/QQ.png"
            alt=""
            style="width: 250px; height: 270px"
          />
          <img
            src="@/assets/QQ-icon.png"
            alt=""
            style="
              width: 50px;
              height: 50px;
              margin-top: 20px;
              margin-right: 20px;
            "
          />
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          "
        >
          <img
            src="@/assets/officialwechat.png"
            alt=""
            style="width: 250px; height: 270px"
          />
          <img
            src="@/assets/public-icon.png"
            alt=""
            style="
              width: 50px;
              height: 50px;
              margin-top: 20px;
              margin-right: 20px;
            "
          />
        </div>
      </div>
      <div style="height: 20px; width: 100%; background-color: #fff"></div>
      <!--      <img src="@/assets/themap.png" alt="" />-->
      <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler" ak="Lg5otFdmeXF9fMX67dF96E2nIQS6K0Wf">
        <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="true"></bm-overview-map>
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
        <bm-marker :position="{lng: 116.33557, lat: 39.972453}" :dragging="false" animation="BMAP_ANIMATION_BOUNCE">
          <bm-label content="恒润国际大厦" title="恒润国际大厦" :position="{lng: 116.33557, lat: 39.972453}" :labelStyle="{color: 'red', fontSize : '14px'}"/>
        </bm-marker>
      </baidu-map>
      <div
        style="
          background-color: #fff;
          padding: 10px;
          font-size: 15px;
          font-weight: bold;
          width: 100%;
          margin-top: 10px;
        "
      >
        <p>联系电话：010-5367 2266</p>
        <p>服务时间：周一至周五（8：30-17：00）</p>
        <p>地址：北京市海淀区北三环西路32号恒润国际大厦602室</p>
      </div>
    </div>
  </div>
</template>
<script>

// import Vue from 'vue'
// import BaiduMap from 'vue-baidu-map'
//
// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'Lg5otFdmeXF9fMX67dF96E2nIQS6K0Wf'
// })
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import { BmNavigation,BmOverviewMap,BmMarker,BmGeolocation,BmScale,BmLabel } from "vue-baidu-map";
// import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue'
// import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
// import BmNavigation from 'vue-baidu-map/components/controls/Navigation.vue'
// import BmOverviewMap from 'vue-baidu-map/components/controls/OverviewMap.vue'
// import BmScale from 'vue-baidu-map/components/controls/Scale.vue'
export default {
  //组件名字
  name: "ContactUs",
  //组件参数
  props: {},
  //组件状态数据值
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3,
    };
  },
  //计算属性
  computed: {},
  components: {
    BaiduMap,
    BmNavigation,
    BmOverviewMap,
    BmMarker,
    BmGeolocation,
    BmScale,
    BmLabel
  },
  //方法
  methods: {
    handler({ BMap, map }) {
      console.log(BMap, map);
      this.center.lng = 116.33557;
      this.center.lat = 39.972453;
      this.zoom = 15;
    },
  },
};
</script>
<style lang="less">
.map {
  width: 100%;
  height: 500px;
}
</style>
